<template>
  <div class="container-fluid">
    <div class="loading" v-if="loading">Loading&#8230;</div>

    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Roles y permisos</h1>
          <p class="view-header__subtitle">Definí los roles del sistema y los permisos que puede ejercer cada uno.</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="openNewRole">
            <i class="bi bi-plus-lg"></i>
            Nuevo rol
          </button>
        </div>
      </div>
    </div>

    <!-- TABLA -->
    <div class="data-table">
      <div class="table-responsive">
        <table class="table mb-0">
          <thead>
            <tr>
              <th>Rol</th>
              <th>Descripción</th>
              <th class="text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="role in roles" :key="role.id">
              <td><span class="data-table__primary">{{ role.name }}</span></td>
              <td class="data-table__muted">{{ role.description }}</td>
              <td class="text-right">
                <div v-if="role.company_id !== null" class="table-action-group">
                  <button class="table-action-btn" type="button" title="Editar" @click="openEditRole(role)">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button class="table-action-btn" type="button" title="Borrar" @click="remove(role)">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="!loading && roles.length === 0">
              <td colspan="3" class="data-table__empty">No hay roles cargados</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- MODAL NUEVO / EDITAR ROL -->
    <transition name="modal">
      <div v-if="showRoleModal" class="modal-mask-product">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="form-card__header">
              <h6 class="form-card__title">
                <i :class="roleId == null ? 'bi bi-plus-lg' : 'bi bi-pencil'"></i>
                {{ roleId == null ? 'Nuevo rol' : 'Editar rol' }}
              </h6>
              <button type="button" class="form-card__btn" @click="closeRoleModal">
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div class="modal-body">
              <NewRole
                :permissionsList="permissions"
                :roleId="roleId"
                @confirmsave="onRoleSaved"
                @close="closeRoleModal"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import NewRole from "../../sub-components/New-role.vue";

export default {
  components: {
    NewRole,
  },
  data: function () {
    return {
      loading: false,
      roleId: null,
      roles: [],
      permissions: [],
      showRoleModal: false,
    }
  },
  mounted() {
    this.refreshTable();
  },
  methods: {
    refreshTable() {
      const vm = this;
      vm.loading = true;
      this.$http
        .get('/api/configs/role/getData', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        })
        .then((response) => {
          vm.roles = response.data.data.roles;
          vm.permissions = response.data.data.permissions;
        })
        .then(() => {
          vm.loading = false;
        });
    },
    openNewRole() {
      this.roleId = null;
      this.showRoleModal = true;
    },
    openEditRole(role) {
      this.roleId = role.id;
      this.showRoleModal = true;
    },
    closeRoleModal() {
      this.showRoleModal = false;
      this.roleId = null;
    },
    onRoleSaved() {
      this.closeRoleModal();
      this.refreshTable();
    },
    remove(data) {
      const vm = this;
      if (
        confirm("¿Está seguro que desea borrar este Rol?") == true
      ) {
        this.$http
          .post(`/api/configs/role/delete/${data.id}`)
          .then((response) => {
            
            if (response.data.code == 200) {
              vm.refreshTable();
            }
          });
      }
    }
  },


}
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
}

.modal-content {
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--surface);
}

.modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  -webkit-overflow-scrolling: touch;
}

@media (min-width: 768px) {
  .modal-mask-product {
    align-items: center;
    padding: 24px;
  }

  .modal-dialog {
    height: auto;
    max-width: 720px;
    max-height: calc(100vh - 48px);
  }

  .modal-content {
    height: auto;
    max-height: calc(100vh - 48px);
    border: 1px solid var(--border-soft);
    border-radius: 12px;
    box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  }

  .modal-body {
    max-height: 70vh;
    padding: 20px 24px;
  }
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
